define('app/models/search_product',['app/setup'], function(takhfifan) {

  takhfifan.SearchProduct = Backbone.Model.extend({
  });

});

